import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  lightText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0',
    color: '#6A777A',
  },
}))
